<template>
    <el-card shadow="hover">
        <label slot="header">色块统计</label>
        <el-divider content-position="left">shade="#90EE90" desc="颜色范围，无数字" :value="88" :color="['#9370DB', '#87CEFA']"</el-divider>
        <!--      无图标，背景渐变自动计算-->
        <j-colour shade="#75d7d5" desc="无图标，背景渐变自动计算" :value="88" />
        <!--      颜色范围，无数字,使用图片作为插槽内容-->
        <j-colour :color="['#9370DB', '#87CEFA']" desc="颜色范围，无数字11111112222222">
            <img slot="icon" src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg" alt="test">
        </j-colour>
        <j-colour shade="#90EE90" desc="颜色范围，无数字" :value="88" >
            <img slot="icon" src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg" alt="test">
        </j-colour>
        <j-colour shade="#90EE90" desc="svg图标" :value="88" >
            <j-svg-icon slot="icon" name="xtwh"/>
        </j-colour>
    </el-card>
</template>

<script>
    import JColour from "./JColour";
    export default {
        components: {
            JColour
        },
        data() {
            return {}
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>

</style>
